import * as React from "react";
const SvgFiRrBrailleNAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M11 3.5C11 5.43 9.43 7 7.5 7S4 5.43 4 3.5 5.57 0 7.5 0 11 1.57 11 3.5M16.5 7C18.43 7 20 5.43 20 3.5S18.43 0 16.5 0 13 1.57 13 3.5 14.57 7 16.5 7m0 1C14.57 8 13 9.57 13 11.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5S18.43 8 16.5 8m0 8c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5m-9-8C5.57 8 4 9.57 4 11.5S5.57 15 7.5 15s3.5-1.57 3.5-3.5S9.43 8 7.5 8M11 19.5c0 1.93-1.57 3.5-3.5 3.5S4 21.43 4 19.5 5.57 16 7.5 16s3.5 1.57 3.5 3.5m-2 0c0-.827-.673-1.5-1.5-1.5S6 18.673 6 19.5 6.673 21 7.5 21 9 20.327 9 19.5"
    />
  </svg>
);
export default SvgFiRrBrailleNAlt;
